import { render } from "./CompanyTextCard.vue?vue&type=template&id=508fb29f"
import script from "./CompanyTextCard.vue?vue&type=script&lang=js"
export * from "./CompanyTextCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__